import { IconButton, ListItem, ListItemSecondaryAction, ListItemText, withStyles } from '@material-ui/core';
import Delete from '@material-ui/icons/Delete';
import React, { PureComponent } from 'react';
import QueryTypeIndicator from './QueryTypeIndicator';

const styles = {
    root: {
        paddingLeft: '16px',
        paddingRight: '16px'
    },
    container: {
        '&:hover $secondaryAction': {
            opacity: 1
        }
    },
    secondaryAction: {
        opacity: 0,
        transition: 'opacity 150ms cubic-bezier(0.4, 0, 0.2, 1)'
    },
    deleteButton: {
        fontSize: '20px',
        width: 32,
        height: 32
    }
};

class QueryItem extends PureComponent {
    render() {
        return (
            <ListItem button onClick={this._handleClickQuery} classes={{
                root: this.props.classes.root,
                container: this.props.classes.container
            }}>
                <QueryTypeIndicator type={this.props.query.type}/>
                <ListItemText primary={this.props.query.name}/>
                <ListItemSecondaryAction classes={{
                    root: this.props.classes.secondaryAction
                }}>
                    <IconButton classes={{
                        root: this.props.classes.deleteButton
                    }} aria-label="Delete" onClick={this._handleClickDelete}>
                        <Delete fontSize="inherit" />
                    </IconButton>
                </ListItemSecondaryAction>
            </ListItem>
        )
    }

    _handleClickQuery = () => {
        this.props.onClickQuery(this.props.query);
    };

    _handleClickDelete = () => {
        this.props.onDeleteQuery(this.props.query);
    };
}

export default withStyles(styles)(QueryItem);



// WEBPACK FOOTER //
// ./src/components/QueryItem.js